export default __webpack_public_path__ + "static/assets/b1c9af801b397e40801d824934259243.png";